import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import CaldaiaForm from "./TechinicianForm";
import Actions from "../TechiniciansActions";
import Store from "../TechiniciansStore";
import { TechnicianData } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";


interface Props extends RouteComponentProps<{ id?: string }> {
}
const TechnicianEdit = (props: Props) => {

    const { history, match } = props;
    const id = match.params.id;

    const caldaia = id ? Store.use(+id) : new TechnicianData;
    if (!caldaia)
        return <Loading />

    const save = async (caldaia: TechnicianData) => {
        if (id) {
            Actions.update(+id, caldaia);
        }
        else {
            const { id } = await Actions.add(caldaia);
            history.replace(links.technicianEdit(id))
        }
    }

    const dto = new TechnicianData();
    if (caldaia)
        dto.init(caldaia);

    return (
        <CaldaiaForm
            technician={dto}
            onSubmit={save}
            onCancel={() => history.goBack()}
        />
    );
}


export default withRouter(TechnicianEdit);